<template>

	<div class="parallax"></div>

</template>

<script>

	import $ from 'jquery'
	import "jquery-parallax.js"

	export default {
		name: "parallax",
		props: {
			src: {
				type: String,
				required: true
			},
			config: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		data () {
			return {
				height: 0,
				timeout: null
			}
		},
		mounted () {
			this.init()
			$(window).on("scroll", this.setHeight)
		},
		methods: {
			init () {
				const config = Object.assign({}, this.config, { imageSrc: this.src })
				$(this.$el).parallax(config)
			},
			setHeight () {
				this.height = $(this.$el).height()
			}
		},
		destroyed () {
			$(window).off("scroll", this.setHeight)
			$(this.$el).parallax('destroy')
		},
		watch: {
			height () {
				$(window).trigger("resize")
			}
		}
	}

</script>

<style lang="scss" scoped>



</style>



// WEBPACK FOOTER //
// src/components/Parallax.vue